export default __webpack_public_path__ + "locales/de/Settings.json?hash=642af2508582574fc0627851c3ff6cc1";